import styles from "./styles.module.scss";

export const Spinner = ({isWalky}) => {
  return <div className={isWalky ? styles.spinnerWalky : styles.spinner}></div>;
};
